// extracted by mini-css-extract-plugin
module.exports = {"logo":"Nav_logo__348g8","path":"Nav_path__3bBuB","normal":"Nav_normal__1l64Q","hidden":"Nav_hidden__3a5Dm"};